import React from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import {
  ThumbFaveBiEvent,
  ThumbClickUnfaveBiEvent,
  BiData,
} from '@wix/da-bi/pkg/events';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';

export interface Props {
  deviation: PapiDeviation;
  isFavourite: boolean;
  faveCount: number;
  isLoading: boolean;
  className?: string;
  ['aria-label']?: string;
  notificationQueue?: string;
  children(props: { isFavourite: boolean; faveCount: number }): React.ReactNode;
  onChangeFave: (
    deviation: PapiDeviation,
    to: boolean,
    notificationQueue: string
  ) => void;
}

type FaveOrUnfaveBiEvent = ThumbFaveBiEvent | ThumbClickUnfaveBiEvent;

class FaveButton extends React.Component<Props> {
  render() {
    const {
      deviation,
      isFavourite,
      faveCount,
      isLoading,
      className,
      'aria-label': ariaLabel,
    } = this.props;

    return (
      <ErrorBoundary debugComponent="FaveButton">
        <BiButton
          disabled={isLoading}
          onClick={this.onFaveToggle}
          className={className}
          aria-label={ariaLabel}
          biData={BiData<FaveOrUnfaveBiEvent>({
            evid: isFavourite ? 109 : 102,
            creatorid: deviation.author
              ? deviation.author.useridUuid
              : undefined,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
          })}
        >
          {this.props.children({ isFavourite, faveCount })}
        </BiButton>
      </ErrorBoundary>
    );
  }

  onFaveToggle = () => {
    const {
      deviation,
      onChangeFave,
      isFavourite,
      notificationQueue = 'default',
    } = this.props;
    onChangeFave && onChangeFave(deviation, !isFavourite, notificationQueue);
  };
}

export default FaveButton;
